<template>
  <el-container class="admin">
    <el-header class="app-header">
        <admin-nav/>
    </el-header>
    <el-main>

       <div class="admin-breadcrumb">
          <div class="admin-page-info">
            <h1 class="h1 brand">{{ componentName }}</h1>
          </div>
          <div>
            <el-breadcrumb separator=">">
            <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
            <el-breadcrumb-item><a href="/">{{componentName}}</a></el-breadcrumb-item>
          </el-breadcrumb>
          </div>
       </div>

      <div class="admin-content">
       <router-view :user="user"></router-view>
     </div>
    </el-main>
  </el-container>
</template>

<script>
import AdminNav from './AdminNav'
import { getUserInfo } from '@/services/auth'

export default {
  name: 'AdminPage',
  components: {
    'admin-nav': AdminNav
  },
  data () {
    return {
      user: {
        super_user: false
      },
      componentName: 'Admin'
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.checkUserInfo(to)
    })
  },
  watch: {
    '$route' (to, from) {
      this.checkUserInfo(to)
      this.setPageTitle(to)
    }
  },
  mounted () {
    this.setPageTitle(this.$route)
  },

  methods: {

    setPageTitle (to) {
      if (to.meta && to.meta.title) {
        this.componentName = to.meta.title
      } else {
        this.componentName = to.name
      }
    },
    validatePageAccess (user, to) {
      // check that only superuser access all pages
      const userType = user.user_type
      const isSuperUser = user.is_superuser
      if (isSuperUser) {
        return true
      }
      const { allowAccess, roles } = to.meta
      if (allowAccess && roles && userType && roles.includes(userType)) {
        return true
      } else {
        // redirect the user to the unauthorized page
        this.$router.push('/')
      }
    },

    checkUserInfo (to) {
      getUserInfo()
        .then(res => {
          this.user = res.data
          this.validatePageAccess(res.data, to)
        })
        .catch(() => {
          // silently push the user to the home page
          this.$router.push('/')
        })
    }
  }
}
</script>

<style src="./admin.scss" lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/AdminPage.vue